import Vue from "vue";

export async function index(leadId) {
    const response = await Vue.prototype.$http.get(`leads/${leadId}/property-registries`);

    return response.data.data;
}

export async function update(leadId, propertyRegistryId, data) {
    const response = await Vue.prototype.$http.patch(
        `leads/${leadId}/property-registries/${propertyRegistryId}`,
        data
    );

    return response.data.data;
}

export async function reprocess(leadId, propertyRegistryId) {
    const response = await Vue.prototype.$http.post(
        `leads/${leadId}/property-registries/${propertyRegistryId}/reprocess`
    );

    return response.data;
}

export async function destroy(leadId, propertyRegistryId) {
    const response = await Vue.prototype.$http.delete(
        `leads/${leadId}/property-registries/${propertyRegistryId}`
    );

    return response.data;
}